// drawOla feature toggles.
// Flip a value to enable/disable a feature. Keep this file at the app level
// so upstream merges never touch it. UI code imports from here and wraps
// optional blocks with `DRAWOLA:CUSTOM` marker comments for easy grep.
export const DRAWOLA_FEATURES = {
  /** AI tools in the extra-tools ("Generate") dropdown: Text->Diagram, Wireframe->Code. */
  SHOW_AI_TOOLS: false,
  /** "Mermaid to Excalidraw" entry (and its "Generate" section heading) in
   *  the toolbar's extra-tools ("...") dropdown. Hidden via a CSS gate in
   *  index.scss (drawOla-hide-mermaid-import), since there is no upstream
   *  prop to hide just this one item. Does not affect the command palette's
   *  own Mermaid entry, which is already gated separately by SHOW_AI_TOOLS. */
  SHOW_MERMAID_IMPORT: false,
  /** Live collaboration entry in the main menu. */
  SHOW_LIVE_COLLAB: true,
  /** drawOla+ integrations: main-menu upsell link, "Export to drawOla+" card in the Open (overwrite-confirm) dialog and the Save-to JSON export dialog, and the drawOla+ + Export-to-drawOla+ entries in the command palette. */
  SHOW_DRAWOLA_PLUS: false,
  /** Bundled upstream Socials block (GitHub + X/Follow us + Discord). */
  SHOW_SOCIALS: false,
  /** Sign up / Sign in link in the main menu. */
  SHOW_SIGN_UP: false,
  /** Visual Debug entry (dev-only) in the main menu. */
  SHOW_VISUAL_DEBUG: false,
  /** drawOla+ promo banner in the top-right corner. */
  SHOW_PLUS_PROMO_BANNER: false,
  /** Share / Live Collaboration button in the top-right corner. */
  SHOW_SHARE_BUTTON: true,
  /** "Get shareable link" actions: editor main menu and the Studio per-card
   *  menu. Uploads an encrypted copy of the scene to the share backend and
   *  shows the generated link. The receiver imports it as their own new draw. */
  SHOW_SHARE_LINK: true,
  /** Library trigger button in the top-right corner (opens the library sidebar). */
  SHOW_LIBRARY: false,
  /** Render the Library sidebar as a floating Island on the middle-right of
   *  the canvas (matching the top toolbar's rounded / shadowed look) instead
   *  of as a full-height docked side panel. CSS-only override; no behavior
   *  change. Has no effect unless the library is actually shown. */
  FLOAT_LIBRARY: true,
  /** Encrypted shield icon (with tooltip link) in the bottom-right footer. */
  SHOW_ENCRYPTED_ICON: false,
  /** "Find on canvas" (SearchMenu) entry in the main menu. */
  SHOW_FIND_ON_CANVAS: false,
  /** Minimap thumbnail navigation panel in the bottom-right corner. */
  SHOW_MINIMAP: true,
  /** Multi-file local storage (IndexedDB-backed). When on, drawOla manages
   *  multiple documents, shows the file-list sidebar and the storage meter. */
  ENABLE_MULTI_FILE_STORE: true,
  /** Gates the oversized image import prompt. When on, images over the
   *  import size limit are compressed before they are added to the scene. */
  ENABLE_IMAGE_IMPORT_LIMIT: true,
  /** Cloud storage sync (Google Drive first, Dropbox / OneDrive / pCloud
   *  later). Phase 1 ships a UI shell backed by a mock provider; real
   *  adapters land in Phase 3+. Ships dark. */
  SHOW_CLOUD_STORAGE: true,
  /** Mindmap feature: main-menu entry to drop a root mindmap block at the
   *  viewport center. Phase 0 inserts only the root block; +icons / sibling
   *  / child creation land in later phases. */
  SHOW_MINDMAP: true,
  /** "Drawola Studio" home view. When on, the app boots into a document
   *  browser (grid/list of every draw) instead of straight into the editor,
   *  and the main menu gets a "Drawola Studio" entry to go back home.
   *  Collab / share / add-library deep links always bypass it and open the
   *  editor directly. When off, the app behaves exactly as before.
   *  Requires ENABLE_MULTI_FILE_STORE (the Studio lists its documents). */
  SHOW_STUDIO_HOME: true,
} as const;
